import React, {useState, useEffect} from 'react';
import debounce from 'debounce';
import {Formik} from 'formik';
import DataTableWithFiltersView from './DataTableWithFilters-view';
import dayjs from "dayjs";

const DELAY = 500;

const DataTableWithFilters = ({
                                shumaId,
                                page,
                                setPage,
                                getListHandler,
                                getListForExcelHandler,
                                data,
                                cities,
                                streets,
                                updateStreets,
                                filtersPresistanceOptions = null,
                                ...rest
                              }) => {
  const [sortColumnName, setSortColumnName] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  const restoreFilter = (key, defaultValue = '', isDate = false) => {
    if (filtersPresistanceOptions) {
      const prevValue = filtersPresistanceOptions.previousFilters[key];
      if (prevValue !== undefined && prevValue !== null) {
        return isDate ? new Date(prevValue) : prevValue;
      } else {
        return defaultValue;
      }
    } else {
      return defaultValue;
    }
  };

  const [city, setCity] = useState(restoreFilter('city'));
  const [street, setStreet] = useState(restoreFilter('street'));
  const [houseNumber, setHouseNumber] = useState(restoreFilter('houseNumber'));
  const [fromGush, setFromGush] = useState(restoreFilter('fromGush'));
  const [toGush, setToGush] = useState(restoreFilter('toGush'));
  const [fromHelka, setFromHelka] = useState(restoreFilter('fromHelka'));
  const [toHelka, setToHelka] = useState(restoreFilter('toHelka'));
  const [propertyType, setPropertyType] = useState(restoreFilter('propertyType'));
  const [fromSalePrice, setFromSalePrice] = useState(restoreFilter('fromSalePrice'));
  const [toSalePrice, setToSalePrice] = useState(restoreFilter('toSalePrice'));
  const [fromSaleDate, setFromSaleDate] = useState(restoreFilter('fromSaleDate', '', true));
  const [toSaleDate, setToSaleDate] = useState(restoreFilter('toSaleDate', '', true));
  const [fromRoomsCount, setFromRoomsCount] = useState(restoreFilter('fromRoomsCount'));
  const [toRoomsCount, setToRoomsCount] = useState(restoreFilter('toRoomsCount'));
  const [fromRegisteredArea, setFromRegisteredArea] = useState(restoreFilter('fromRegisteredArea')); //net
  const [toRegisteredArea, setToRegisteredArea] = useState(restoreFilter('toRegisteredArea'));
  //extra
  const [fromEstimatePrice, setFromEstimatePrice] = useState(restoreFilter('fromEstimatePrice'));
  const [toEstimatePrice, setToEstimatePrice] = useState(restoreFilter('toEstimatePrice'));
  const [sellType, setSellType] = useState(restoreFilter('sellType'));
  const [floor, setFloor] = useState(restoreFilter('floor'));
  const [floorsCount, setFloorsCount] = useState(restoreFilter('floorsCount'));
  const [fromBuildYear, setFromBuildYear] = useState(restoreFilter('fromBuildYear', '', true));
  const [toBuildYear, setToBuildYear] = useState(restoreFilter('toBuildYear', '', true));
  const [buildingAge, setBuildingAge] = useState(restoreFilter('buildingAge'));
  const [buildingUnitFunction, setBuildingUnitFunction] = useState(restoreFilter('buildingUnitFunction'));
  const [fromMunicipalArea, setFromMunicipalArea] = useState(restoreFilter('fromMunicipalArea')); //brutto
  const [toMunicipalArea, setToMunicipalArea] = useState(restoreFilter('toMunicipalArea'));
  const [soldShare, setSoldShare] = useState(restoreFilter('soldShare'));
  const [parking, setParking] = useState(restoreFilter('parking'));
  const [elevator, setElevator] = useState(restoreFilter('elevator'));
  const [gallery, setGallery] = useState(restoreFilter('gallery'));
  const [yard, setYard] = useState(restoreFilter('yard'));
  const [storage, setStorage] = useState(restoreFilter('storage'));
  const [roof, setRoof] = useState(restoreFilter('roof'));
  const [lot, setLot] = useState(restoreFilter('lot'));
  const [removeDuplicates, setRemoveDuplicates] = useState(restoreFilter('removeDuplicates')); //custom

  const handleSearchChange = (key, handler) => value => {
    setPage(0);
    handler(value);
    if (filtersPresistanceOptions) {
      filtersPresistanceOptions.saveFilter({[key]: value});
    }
  };
  const handleCityChange = value => {
    setPage(0);
    setCity(value);
    if (filtersPresistanceOptions) {
      filtersPresistanceOptions.saveFilter({'city': value});
    }
    handleSearchReset('street', setStreet)();
    if (Boolean(value.value)) {
      updateStreets(value.value);
    } else {
      handleCityReset();
    }
  };
  const handleSearchReset = (key, handler) => () => {
    handleSearchChange(key, handler)(null);
  };
  const handleCityReset = () => {
    handleSearchReset('city', setCity)();
    handleSearchReset('street', setStreet)();
  };

  const requestBody = {
    shumaId: shumaId ? parseInt(shumaId) : 0,
    city: (city) ? city.label : '',
    street: (street) ? street.label : '',
    houseNumber: houseNumber || '',
    fromGush: fromGush || '',
    toGush: toGush || '',
    fromHelka: fromHelka || '',
    toHelka: toHelka || '',
    propertyType: propertyType || '',
    fromSalePrice: fromSalePrice || '',
    toSalePrice: toSalePrice || '',
    fromSaleDate: fromSaleDate ? dayjs(fromSaleDate).format('YYYY-MM-DD') : '',
    toSaleDate: toSaleDate ? dayjs(toSaleDate).format('YYYY-MM-DD') : '',
    fromRegisteredArea: fromRegisteredArea || '',
    toRegisteredArea: toRegisteredArea || '',
    fromRoomsCount: fromRoomsCount || '',
    toRoomsCount: toRoomsCount || '',
    fromEstimatePrice: fromEstimatePrice || '',
    toEstimatePrice: toEstimatePrice || '',
    sellType: sellType || '',
    floor: floor || '',
    floorsCount: floorsCount || '',
    fromBuildYear: fromBuildYear ? dayjs(fromBuildYear).format('YYYY') : '',
    toBuildYear: toBuildYear ? dayjs(toBuildYear).format('YYYY') : '',
    buildingAge: buildingAge || '',
    buildingUnitFunction: buildingUnitFunction || '',
    fromMunicipalArea: fromMunicipalArea || '',
    toMunicipalArea: toMunicipalArea || '',
    soldShare: soldShare ? 1 : 0,
    parking: parking ? 1 : 0,
    elevator: elevator ? 1 : 0,
    gallery: gallery ? 1 : 0,
    yard: yard ? 1 : 0,
    storage: storage ? 1 : 0,
    roof: roof ? 1 : 0,
    lot: lot ? 1 : 0,
    removeDuplicates: removeDuplicates ? 1 : 0
  };

  const refreshGrid = debounce(() => {
    getListHandler({...requestBody, sortBy: sortColumnName, sortDirection, requestedPageNumber: page});
  }, DELAY);

  useEffect(() => {
    refreshGrid();
  }, [
    page,
    city, street, houseNumber,
    fromGush, toGush,
    fromHelka, toHelka,
    propertyType, fromSalePrice, toSalePrice,
    fromSaleDate, toSaleDate,
    fromRegisteredArea, toRegisteredArea,
    fromRoomsCount, toRoomsCount,
    fromEstimatePrice, toEstimatePrice,
    sellType, floor, floorsCount,
    fromBuildYear, toBuildYear, buildingAge, buildingUnitFunction,
    fromMunicipalArea, toMunicipalArea,
    soldShare, parking, elevator, gallery, yard,
    storage, roof, lot, removeDuplicates,
  ]);

  const handleSortChange = debounce((column, direction) => {
    setSortColumnName(column);
    setSortDirection(direction);
    getListHandler({...requestBody, sortBy: column, sortDirection: direction, requestedPageNumber: page})
  }, DELAY);

  const resetAllFilters = () => {
    setCity(-1);
    setStreet(-1);
    setHouseNumber('');
    setFromGush('');
    setToGush('');
    setFromHelka('');
    setToHelka('');
    setPropertyType('');
    setFromSalePrice('');
    setToSalePrice('');
    setFromSaleDate('');
    setToSaleDate('');
    setFromRegisteredArea('');
    setToRegisteredArea('');
    setFromRoomsCount('');
    setToRoomsCount('');
    setFromEstimatePrice('');
    setToEstimatePrice('');
    setSellType('');
    setFloor('');
    setFloorsCount('');
    setFromBuildYear('');
    setToBuildYear('');
    setBuildingAge('');
    setBuildingUnitFunction('');
    setFromMunicipalArea('');
    setToMunicipalArea('');
    setSoldShare(false);
    setParking(false);
    setElevator(false);
    setGallery(false);
    setYard(false);
    setStorage(false);
    setRoof(false);
    setLot(false);
    setRemoveDuplicates(false);
  };

  return (
    <Formik
      initialValues={{
        city: -1,
        street: -1,
        houseNumber: '',
        fromGush: '',
        toGush: '',
        fromHelka: '',
        toHelka: '',
        propertyType: '',
        fromSalePrice: '',
        toSalePrice: '',
        fromSaleDate: '',
        toSaleDate: '',
        fromRegisteredArea: '',
        toRegisteredArea: '',
        fromRoomCount: '',
        toRoomCount: '',
        fromEstimatePrice: '',
        toEstimatePrice: '',
        transactionType: '',
        floor: '',
        floorsCount: '',
        fromBuildYear: '',
        toBuildYear: '',
        buildingAge: '',
        buildingUnitFunction: '',
        fromMunicipalArea: '',
        toMunicipalArea: '',
        soldShare: false,
        parking: false,
        elevator: false,
        gallery: false,
        yard: false,
        storage: false,
        roof: false,
        lot: false,
        removeDuplicates: false,
      }}
      onSubmit={() => {
      }}
      enableReinitialize={true}
    >
      <DataTableWithFiltersView
        search={{
          city: {
            value: city,
            onChange: handleCityChange,
            onReset: handleCityReset,
          },
          street: {
            value: street,
            onChange: handleSearchChange('street', setStreet),
            onReset: handleSearchReset('street', setStreet),
          },
          houseNumber: {
            value: houseNumber,
            onChange: handleSearchChange('houseNumber', setHouseNumber),
          },
          fromGush: {
            value: fromGush,
            onChange: handleSearchChange('fromGush', setFromGush),
          },
          toGush: {
            value: toGush,
            onChange: handleSearchChange('toGush', setToGush),
          },
          fromHelka: {
            value: fromHelka,
            onChange: handleSearchChange('fromHelka', setFromHelka),
          },
          toHelka: {
            value: toHelka,
            onChange: handleSearchChange('toHelka', setToHelka),
          },
          propertyType: {
            value: propertyType,
            onChange: handleSearchChange('propertyType', setPropertyType),
            onReset: handleSearchReset('propertyType', setPropertyType),
          },
          fromSalePrice: {
            value: fromSalePrice,
            onChange: handleSearchChange('fromSalePrice', setFromSalePrice),
          },
          toSalePrice: {
            value: toSalePrice,
            onChange: handleSearchChange('toSalePrice', setToSalePrice),
          },
          fromSaleDate: {
            value: fromSaleDate,
            onChange: handleSearchChange('fromSaleDate', setFromSaleDate),
            onReset: handleSearchReset('fromSaleDate', setFromSaleDate),
          },
          toSaleDate: {
            value: toSaleDate,
            onChange: handleSearchChange('toSaleDate', setToSaleDate),
            onReset: handleSearchReset('toSaleDate', setToSaleDate),
          },
          fromRegisteredArea: {
            value: fromRegisteredArea,
            onChange: handleSearchChange('fromRegisteredArea', setFromRegisteredArea),
          },
          toRegisteredArea: {
            value: toRegisteredArea,
            onChange: handleSearchChange('toRegisteredArea', setToRegisteredArea),
          },
          fromRoomsCount: {
            value: fromRoomsCount,
            onChange: handleSearchChange('fromRoomCount', setFromRoomsCount),
          },
          toRoomsCount: {
            value: toRoomsCount,
            onChange: handleSearchChange('toRoomsCount', setToRoomsCount),
          },
          //extra
          fromEstimatePrice: {
            value: fromEstimatePrice,
            onChange: handleSearchChange('fromEstimatePrice', setFromEstimatePrice),
          },
          toEstimatePrice: {
            value: toEstimatePrice,
            onChange: handleSearchChange('toEstimatePrice', setToEstimatePrice),
          },
          sellType: {
            value: sellType,
            onChange: handleSearchChange('sellType', setSellType),
            onReset: handleSearchReset('sellType', setSellType),
          },
          floor: {
            value: floor,
            onChange: handleSearchChange('floor', setFloor),
          },
          floorsCount: {
            value: floorsCount,
            onChange: handleSearchChange('floorsCount', setFloorsCount),
          },
          fromBuildYear: {
            value: fromBuildYear,
            onChange: handleSearchChange('fromBuildYear', setFromBuildYear),
            onReset: handleSearchReset('fromBuildYear', setFromBuildYear),
          },
          toBuildYear: {
            value: toBuildYear,
            onChange: handleSearchChange('toBuildYear', setToBuildYear),
            onReset: handleSearchReset('toBuildYear', setToBuildYear),
          },
          buildingAge: {
            value: buildingAge,
            onChange: handleSearchChange('buildingAge', setBuildingAge),
          },
          buildingUnitFunction: {
            value: buildingUnitFunction,
            onChange: handleSearchChange('buildingUnitFunction', setBuildingUnitFunction),
          },
          fromMunicipalArea: {
            value: fromMunicipalArea,
            onChange: handleSearchChange('fromMunicipalArea', setFromMunicipalArea),
          },
          toMunicipalArea: {
            value: toMunicipalArea,
            onChange: handleSearchChange('toMunicipalArea', setToMunicipalArea),
          },
          soldShare: {
            value: soldShare,
            onChange: handleSearchChange('soldShare', setSoldShare),
          },
          parking: {
            value: parking,
            onChange: handleSearchChange('parking', setParking),
          },
          elevator: {
            value: elevator,
            onChange: handleSearchChange('elevator', setElevator),
          },
          gallery: {
            value: gallery,
            onChange: handleSearchChange('gallery', setGallery),
          },
          yard: {
            value: yard,
            onChange: handleSearchChange('yard', setYard),
          },
          storage: {
            value: storage,
            onChange: handleSearchChange('storage', setStorage),
          },
          roof: {
            value: roof,
            onChange: handleSearchChange('roof', setRoof),
          },
          lot: {
            value: lot,
            onChange: handleSearchChange('lot', setLot),
          },
          removeDuplicates: {
            value: removeDuplicates,
            onChange: handleSearchChange('removeDuplicates', setRemoveDuplicates),
          },
        }}
        data={data}
        getListForExcel={async () => await getListForExcelHandler({
          ...requestBody,
          sortBy: sortColumnName,
          sortDirection
        })}
        options={{cities, streets}}
        page={page}
        setPage={setPage}
        refreshGrid={refreshGrid}
        onSortChange={handleSortChange}
        sortColumnName={sortColumnName}
        sortDirection={sortDirection}
        allowSorting={true}
        resetAllFilters={resetAllFilters}
        {...rest}
      />
    </Formik>
  );
};

export default DataTableWithFilters;